import Vue from "vue";
import Vuex from "vuex";
import _, { set } from "lodash";

import animation from "./animation";
import compose from "./compose";
import contextmenu from "./contextmenu";
import copy from "./copy";
import directives from "./directives";
import directiveTypes from "./directiveTypes";
import events from "./events";
import layer from "./layer";
import snapshot from "./snapshot";
import user from "./user";
import appLayout from "./appLayout";
import lock from "./lock";
import projectLevels from "./projectLevels";
import eventBus from "@/utils/eventBus";
import rtspAdressGroup from "./rtspAdressGroup";
import { BACK_COMPONENT } from "./../utils/attrNameData";
import publicResource from './publicResource';
import env from './env';
import apk from './apk';
import qt from './qt';
import { getCurComponentsInd, isEmpty } from '@/utils/utils';

Vue.use(Vuex);

const data = {
  state: {
    ...animation.state,
    ...compose.state,
    ...contextmenu.state,
    ...copy.state,
    ...directives.state,
    ...events.state,
    ...layer.state,
    ...snapshot.state,
    ...lock.state,
    ...directiveTypes.state,
    ...user.state,
    ...appLayout.state,
    ...projectLevels.state,

    editMode: "edit", // 编辑器模式 edit preview
    canvasStyleData: {
      // 页面全局数据
      width: 1200,
      height: 740,
      scale: 100,
    },
    projectStyleData: {
      // 页面全局数据
      width: 1200,
      height: 740,
      scale: 100,
    },
    pageOptions: [
      {
        label: "新页面1",
        value: 1,
      },
    ],
    componentData: [BACK_COMPONENT()], // 画布组件数据
    canvasAllData: null, // 当前项目所有缓存数据（懒加载时可能含骨架页）
    cacheCanvasDataKey: '', // 缓存当前项目数据的key
    /** 是否启用画布按页懒加载 */
    canvasLazyLoad: false,
    /** 已完整加载的页面 id 映射 { [pageId]: true } */
    canvasLoadedPageIds: {},
    /** 服务端按钮总数（懒加载配额估算） */
    canvasServerButtonCount: 0,
    /** 工程已引用图片资源（懒保存时与当前页图片合并，避免丢未加载页资源） */
    projectFileResouces: [],
    /** 正在离开画布页：禁止异步草稿回写，避免影响下一次新建/编辑 */
    canvasEditorLeaving: false,
    /** 当前 componentData 所属页面 id，切页过程中防止把 A 页画布写进 B 页 */
    componentDataPageId: null,
    /** 切页进行中：暂停自动草稿，避免用错页数据覆盖 */
    canvasPageSwitching: false,
    curComponent: null,
    curComponentIndex: null,
    // 点击画布时是否点中组件，主要用于取消选中组件用。
    // 如果没点中组件，并且在画布空白处弹起鼠标，则取消当前组件的选中状态
    isClickComponent: false,
    // 当前选中的页面id
    selectedCurrentPage: 1,
    // 是否是子页面
    isChildPage: false,
    //解决粘贴复制的冒泡问题： 如果有dialog显示出来，则将该值变为true
    isEditorOnBlur: false,
    // 当前页面的错误信息
    curErrorMap: {},
    // 项目保存时验证需要用到的暂存数据
    projectValidateMap: {}
  },
  actions: {
    ...directiveTypes.actions,
    ...projectLevels.actions,
  },
  mutations: {
    ...animation.mutations,
    ...compose.mutations,
    ...contextmenu.mutations,
    ...copy.mutations,
    ...directives.mutations,
    ...events.mutations,
    ...layer.mutations,
    ...snapshot.mutations,
    ...lock.mutations,
    ...directiveTypes.mutations,
    ...user.mutations,
    ...appLayout.mutations,
    ...rtspAdressGroup.mutations,
    ...projectLevels.mutations,

    setCanvasAllData(state, val) {
      if (state.canvasEditorLeaving) {
        return;
      }
      state.canvasAllData = val;
    },
    setCacheCanvasDataKey(state, val) {
      if (state.canvasEditorLeaving) {
        return;
      }
      state.cacheCanvasDataKey = val;
    },
    setCanvasLazyLoad(state, val) {
      state.canvasLazyLoad = !!val;
    },
    setCanvasLoadedPageIds(state, val) {
      state.canvasLoadedPageIds = val && typeof val === "object" ? val : {};
    },
    markCanvasPageLoaded(state, pageId) {
      if (pageId === undefined || pageId === null) {
        return;
      }
      state.canvasLoadedPageIds = {
        ...state.canvasLoadedPageIds,
        [String(pageId)]: true,
      };
    },
    setComponentDataPageId(state, pageId) {
      state.componentDataPageId =
        pageId === undefined || pageId === null ? null : String(pageId);
    },
    setCanvasPageSwitching(state, val) {
      state.canvasPageSwitching = !!val;
    },
    unmarkCanvasPageLoaded(state, pageId) {
      if (pageId === undefined || pageId === null) {
        return;
      }
      const next = { ...state.canvasLoadedPageIds };
      delete next[String(pageId)];
      state.canvasLoadedPageIds = next;
    },
    setCanvasServerButtonCount(state, val) {
      state.canvasServerButtonCount = Number(val) || 0;
    },
    setProjectFileResouces(state, val) {
      state.projectFileResouces = Array.isArray(val) ? val : [];
    },
    removeCache(state) {
      state.canvasAllData = null;
      state.cacheCanvasDataKey = "";
      state.canvasLazyLoad = false;
      state.canvasLoadedPageIds = {};
      state.canvasServerButtonCount = 0;
      state.projectFileResouces = [];
      state.componentData = [BACK_COMPONENT()];
      state.componentDataPageId = null;
      state.canvasPageSwitching = false;
      state.pageOptions = [
        {
          label: "新页面1",
          value: 1,
        },
      ];
      state.selectedCurrentPage = 1;
      state.isChildPage = false;
      state.curComponent = null;
      state.curComponentIndex = null;
      state.curErrorMap = {};
      state.projectValidateMap = {};
      state.canvasStyleData = {
        width: 1200,
        height: 740,
        scale: 100,
      };
      state.projectStyleData = {
        width: 1200,
        height: 740,
        scale: 100,
      };
      state.snapshotIndex = -1;
      state.snapshotData = [];
    },
    setCanvasEditorLeaving(state, val) {
      state.canvasEditorLeaving = !!val;
    },
    setProjectValidateMap(state, val) {
      state.projectValidateMap = val;
    },
    setClickComponentStatus(state, status) {
      state.isClickComponent = status;
    },
    switchIsEditorOnBlur(state, bol) {
      state.isEditorOnBlur = bol;
    },

    setPageOptions(state, data) {
      state.pageOptions = data;
    },

    setCurrPageName(state, data) {
      state.pageOptions.forEach((o) => {
        if (o.value == state.selectedCurrentPage) {
          o.label = data;
        }
      });
    },

    setSelectedCurrentPage(state, key) {
      state.selectedCurrentPage = key;
      const remainErrorData =
        (sessionStorage.getItem("canvasErrorMap") &&
          JSON.parse(sessionStorage.getItem("canvasErrorMap"))) || {};
      state.curErrorMap = remainErrorData[key] || {};

      var isChild = false;
      const keyStr = key != null ? String(key) : "";
      // 当前页面是子页面时，组件是子页面时，不可拖拽
      for (var i = 0;i < state.pageOptions.length;i++) {
        var a = state.pageOptions[i];
        if (String(a.value) === keyStr) {
          break;
        }
        if (a.children && a.children.length !== 0) {
          a.children.map((child) => {
            if (String(child.value) === keyStr) {
              // 说明当前页面是子页面
              isChild = true;
            }
          });
          if (isChild) {
            break;
          }
        }
      }
      state.isChildPage = isChild;
    },
    setCurErrorMap(state) {
      const remainErrorData =
      (sessionStorage.getItem("canvasErrorMap") &&
        JSON.parse(sessionStorage.getItem("canvasErrorMap"))) || {};
      state.curErrorMap = remainErrorData[state.selectedCurrentPage] || {};
    },
    setEditMode(state, mode) {
      state.editMode = mode;
    },

    setCanvasStyle(state, style) {
      state.canvasStyleData = style;
    },

    setProjectStyle(state, style) {
      state.projectStyleData = style;
    },

    setCurComponent(state, { component, index }) {
      state.curComponent = component;
      state.curComponentIndex = index;
    },

    setShapeStyle({ curComponent }, { top, left, width, height, rotate }) {
      if (!isEmpty(top)) curComponent.style.top = top;
      if (!isEmpty(left)) curComponent.style.left = left;
      if (width) curComponent.style.width = width;
      if (height) curComponent.style.height = height;
      if (rotate) curComponent.style.rotate = rotate;
    },

    setShapeSingleStyle({ curComponent }, { key, value }) {
      curComponent.style[key] = value;
    },

    setShapeSingleGroupStyle({ curComponent }, { key, value }) {
      curComponent.groupStyle[key] = value;
    },

    batchSetComponentAttr(state, componentMap = {}) {
      state.componentData.map((item, ind) => {
        let newVal = componentMap[item.id];
        if (newVal) {
          // 更新属性
          Object.keys(newVal).map((key) => {
            if (typeof newVal[key] === 'object' && !(newVal[key] instanceof Array)) {
              Object.keys(newVal[key]).map((objKey) => {
                if (newVal[key][objKey] !== item[key][objKey]) {
                  state.componentData[ind][key][objKey] = newVal[key][objKey];
                }
              });
            } else if (newVal[key] !== item[key]) {
              state.componentData[ind][key] = newVal[key];
            }
          })
        }
      });
    },
  
    setComponentData(state, componentData = []) {
      Vue.set(state, "componentData", componentData);
    },
    componentsAlign(state, key) {
      const { components } = state.areaData;
      // 左对齐和上对齐只需要找最小的
      let isFindMin = ['top', 'left'].includes(key);
      let alignPx = null;
      components.forEach((item,index)=>{
        let _alignPx = null;
        const { left, width, top, height } = item.style
        if(isFindMin) {
          _alignPx = item.style[key]
        } else if(key === 'right') {
          _alignPx = left + width
        } else {
          _alignPx = top + height
        }
        if(index === 0 
          || (isFindMin && _alignPx < alignPx) 
          || (!isFindMin && _alignPx > alignPx)
        ) {
          alignPx = _alignPx
        }
      })
      state.componentData = state.componentData.map((item) => {
        //背景图组件不需要对齐
        if (item.id == "Back") {
          return item;
        }
        // 只对框中元素对齐
        const inGroup = _.findIndex(components, { id: item.id }) > -1;
        if (!inGroup) {
          return item;
        }
        if(isFindMin) {
          item.style[key] = alignPx;
        } else if(key === 'right') {
          item.style.left = alignPx - item.style.width
        } else {
          item.style.top = alignPx - item.style.height
        }
        return item;
      });
      eventBus.$emit("hideArea");
    },
    changeChildPage(state, deletePageVal) {
      var isChange = false;
      var datas = JSON.parse(JSON.stringify(state.componentData));
      for (var i = 0;i < datas.length;i++) {
          var item = datas[i];
          if (item.component === 'ChildPage') {
              var bindVal = item.style.bindPage && item.style.bindPage.value;
              if (bindVal === deletePageVal) {
                  // 绑定的是当前页面，自动清空???
                  datas[i].style.bindPage = null;
                  isChange = true;
                  if (state.curComponent.id === item.id) {
                    // 当前组件数据更新
                    state.curComponent.style.bindPage = null;
                  }
              }
          }
      }
      if (isChange) {
        Vue.set(state, "componentData", datas);
      }
    },
    horizontalEqual(state) {
      const { components } = state.areaData;
      let minLeft = 0;
      let maxRight = 0;
      let totalWidth = 0;
      let idArr = [];
      components.forEach((item,index) => {
        const { left, width } = item.style;
        const right = left + width;
        if(index === 0) {
          minLeft = left;
          maxRight = right;
        } else {
          if(left < minLeft) {
            minLeft = left
          }
          if(right > maxRight) {
            maxRight = right;
          }
        }
        totalWidth = totalWidth + width
        idArr.push({
          id: item.id,
          left,
          width
        })
      })
      idArr = idArr.sort((item,_item)=>item.left - _item.left) 
      const areaWidth = maxRight - minLeft
      const margin = (areaWidth - totalWidth) / (components.length - 1);
      let left = minLeft;
      idArr.forEach((item, index) => {
        if(index !== 0) {
          const ind = components.findIndex(h=>h.id === item.id)
          left = left + margin
          components[ind].style.left = left
        }
        left = left +  item.width
      }) 
      eventBus.$emit("hideArea");
    },
    verticalEqual(state) {
      const { components } = state.areaData;
      let minTop = 0;
      let maxBottom = 0;
      let totalHeight = 0;
      let idArr = [];
      components.forEach((item,index) => {
        const { top, height } = item.style;
        const bottom = top + height;
        if(index === 0) {
          minTop = top;
          maxBottom = bottom;
        } else {
          if(top < minTop) {
            minTop = top
          }
          if(bottom > maxBottom) {
            maxBottom = bottom;
          }
        }
        totalHeight = totalHeight + height
        idArr.push({
          id: item.id,
          top,
          height
        })
      })
      idArr = idArr.sort((item,_item)=>item.top - _item.top) 
      const areaHeight = maxBottom - minTop
      const margin = (areaHeight - totalHeight) / (components.length - 1);
      let top = minTop;
      idArr.forEach((item, index) => {
        if(index !== 0) {
          const ind = components.findIndex(h=>h.id === item.id)
          top = top + margin
          components[ind].style.top = top
        }
        top = top +  item.height
      }) 
      eventBus.$emit("hideArea");
    },
    componentsToSide(state, key) {
      const { width, height } = state.canvasStyleData;
      const { components } = state.areaData;
      state.componentData = state.componentData.map((item) => {
        //背景图组件不需要对齐
        if (item.id == "Back") {
          return item;
        }
        //当有group框的时候，则只对框中元素对齐
        //当没有group框的时候，则对所有元素对齐
        const inGroup =
          !_.isEmpty(components) &&
          _.findIndex(components, { id: item.id }) > -1;
        if (!inGroup && !_.isEmpty(components)) {
          return item;
        }
        if (key == "right") {
          item.style.left = width - item.style.width;
          return item;
        }

        if (key == "bottom") {
          item.style.top = height - item.style.height;
          return item;
        }
        item.style[key] = 0;
        return item;
      });
      eventBus.$emit("hideArea");
    },
    
    batchAddComponents(state, { components, index }) {
      if (index !== undefined) {
        state.componentData.splice(index, 0, ...components);
      } else {
        state.componentData = state.componentData.concat(components)
      }
    },

    addComponent(state, { component, index }) {
      if (index !== undefined) {
        state.componentData.splice(index, 0, component);
      } else {
        state.componentData.push(component);
      }
    },

    deleteComponent(state, index) {
      // state.componentData = state.componentData.filter(
      //   (c) => c.id != state?.curComponent?.id
      // );
      let ret = getCurComponentsInd(state.componentData, state.curComponent);
      let currentId = state.componentData[ret.index].id;
      if (ret.parentInd !== -1) {
        // 生态组件下的子组件
        state.componentData[ret.parentInd].propValue.splice(ret.index, 1);
        if (state.componentData[ret.parentInd].propValue.length === 0) {
          // 如果子按钮全部删除后，需要删除整体组件
          state.componentData.splice(ret.parentInd, 1);
        }
      } else {
        // 先删除掉按钮绑定事件已绑定的数据
        state.componentData.forEach((item, ind) => {
          if (item.events && item.events.clickEvent && item.events.clickEvent.comp === currentId) {
            state.componentData[ind].events.clickEvent.comp = '';
            state.componentData[ind].events.clickEvent.event = '';
          }
        })

        state.componentData.splice(ret.index, 1);
      }
      this.commit("setCurComponent", {
        component: state.componentData.filter((c) => c.id == "Back")[0],
      });

      // 删除当前组件的错误提示
      const data =
        (sessionStorage.getItem("canvasErrorMap") &&
          JSON.parse(sessionStorage.getItem("canvasErrorMap"))) ||
        {};
      delete data[state.selectedCurrentPage][currentId];
      sessionStorage.setItem("canvasErrorMap", JSON.stringify(data));
      this.commit("setCurErrorMap");
    },
    setComponentStyleByIndex(state, { index, top, left, width, height, rotate }) {
      if (!state.componentData || !state.componentData[index]) {
        return;
      }
      if (top) state.componentData[index].style.top = top;
      if (left) state.componentData[index].style.left = left;
      if (width) state.componentData[index].style.width = width;
      if (height) state.componentData[index].style.height = height;
      if (rotate) state.omponentData[index].style.rotate = rotate;
    },
    setEcologicalChildComponentGroupStyleByIndex(state, { index, childInd, top, left }) {
      if (top) state.componentData[index].propValue[childInd].groupStyle.top = top;
      if (left) state.componentData[index].propValue[childInd].groupStyle.left = left;
    },
    setEcologicalChildData({ curComponent }, { index, key, value }) {
      curComponent.propValue[index][key] = value;
    },
    setAreaStyle({areaData}, moveInfo) {
      const { components } = areaData;
      const horizontalMove = 'missX' in moveInfo;
      const verticalMove = 'missY' in moveInfo;
      const { missX, missY } = moveInfo
      if(components.length){
        components.forEach(item => {
          if(horizontalMove) {
            item.style.left += missX;
          }
          if(verticalMove) {
            item.style.top += missY;
          }
        })
      }
      if(horizontalMove) {
        areaData.style.left += missX;
      }
      if(verticalMove) {
        areaData.style.top += missY;
      }
    }
  },
  modules: {
    env,
    publicResource,
    apk,
    qt
  }
};

export default new Vuex.Store(data);
